import { HttpClient } from '../HttpClient';
/**
 * * Get HR Parameters
 */

export const GetHRParameters = async () => {
  try {
    const { data } = await HttpClient.get(`api/Pendo/HRParameters`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
